import { createSlice, type PayloadAction, createAction } from '@reduxjs/toolkit';

import { GenericPayloadType } from '@ezugi/types';

type BoardTogglePayload = undefined | boolean;

// UiState & {
//   videoScale?: number;
//   height?: number;
//   width?: number;
//   videoHeight?: number;
//   videoWidth?: number;
//   feltHeight?: number;
//   feltWidth?: number;
// } // russian poker only

type ProgressBar = {
  label?: string;
} & Record<string, unknown>;

export type UiState = {
  progressBar: ProgressBar;
  myBets: Record<string, unknown>;
  showTutorial: boolean;
  boardToggled: boolean;
  showBettingOptions: boolean; // lottery-tv only -> TO DO: create new lottery specific slice
  isParentWindowFullscreen?: boolean; // oss
  desktopBoardToggleHeight: number;
}

const initialState: UiState = {
  progressBar: {},
  myBets: {},
  showTutorial: true,
  boardToggled: false,
  isParentWindowFullscreen: false,
  showBettingOptions: false,
  desktopBoardToggleHeight: 22,
};

export const progressBarSetAction = createAction<GenericPayloadType>('progressBar/set');
export const progressBarResetAction = createAction('progressBar/reset');
export const myBetsHighlightAction = createAction<boolean>('myBets/highlight');

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    set(state, { payload }: PayloadAction<Partial<UiState>>) {
      return {
        ...state,
        ...payload,
      };
    },
    toggleBoard(state, { payload: value }: PayloadAction<BoardTogglePayload>) {
      return {
        ...state,
        boardToggled: typeof value === 'undefined' ? !state.boardToggled : value,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(progressBarSetAction, (state, { payload }: PayloadAction<GenericPayloadType>) => ({
      ...state,
      progressBar: {
        ...state.progressBar,
        ...payload,
      },
    }));
    builder.addCase(progressBarResetAction, (state) => ({
      ...state,
      progressBar: {},
    }));
    builder.addCase(myBetsHighlightAction, (state, { payload: highlighted = true }) => ({
      ...state,
      myBets: {
        ...state.myBets,
        highlighted,
      },
    }));
  },
});

export const uiActionsFromSlice = uiSlice.actions;
export default uiSlice.reducer;
